import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { SUBSCRIBERS } from "@/constants/testIds";
import { toast, Toaster } from "sonner";

export default function Subscribers() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api
      .get("/subscribers")
      .then(({ data }) => setRows(data.subscribers))
      .catch((e) => toast.error(formatApiError(e)));
  }, []);

  const total = rows.reduce((s, r) => s + (r.amount || 0), 0);

  return (
    <div data-testid={SUBSCRIBERS.container} className="p-10">
      <Toaster position="top-right" richColors />
      <div className="mb-8 flex items-baseline justify-between">
        <div>
          <div className="overline mb-3">Back office</div>
          <h1 className="font-display text-4xl font-black tracking-tighter">
            Paying subscribers
          </h1>
          <p className="text-neutral-500 mt-2 max-w-xl">
            Every business currently on a monthly plan. Cancel & churn
            controls come next.
          </p>
        </div>
        <div className="text-right">
          <div className="overline mb-1">MRR</div>
          <div className="font-display text-3xl font-black">
            ${total.toLocaleString()}
          </div>
        </div>
      </div>

      <div className="bg-white border border-neutral-200 overflow-x-auto">
        {rows.length === 0 ? (
          <div className="p-12 text-center text-neutral-500 text-sm">
            No paying subscribers yet. Close your first customer via the
            Billing page.
          </div>
        ) : (
          <table className="lf-grid">
            <thead>
              <tr>
                <th>Plan</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Subscription ID</th>
                <th>Since</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.session_id}>
                  <td>
                    <div className="font-semibold">
                      {(r.lookup_key || "").replace("_monthly", "")}
                    </div>
                    <div className="text-xs text-neutral-500 font-mono">
                      {r.lookup_key}
                    </div>
                  </td>
                  <td>${(r.amount || 0).toFixed(2)}</td>
                  <td>
                    <span className="pill pill-interested">
                      {r.payment_status}
                    </span>
                  </td>
                  <td className="font-mono text-xs text-neutral-600">
                    {r.stripe_subscription_id || "—"}
                  </td>
                  <td className="text-neutral-500 text-xs">
                    {r.created_at
                      ? new Date(r.created_at).toLocaleDateString()
                      : ""}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
